import { Section } from "@/components/ui/Section";
import { Reveal } from "@/components/common/Reveal";
import { MANIFESTO } from "@/utils/constants";

export const Manifesto = () => (
  <Section id="manifesto" testId="manifesto-section" bg="dark">
    <Reveal>
      <p className="text-weld-glow font-semibold tracking-[0.25em] uppercase text-sm mb-3">Our Standard</p>
      <h2 className="font-display text-5xl md:text-7xl text-white max-w-3xl leading-[0.95]">
        Three principles behind every weld.
      </h2>
    </Reveal>

    <div className="mt-16 flex flex-col divide-y divide-white/10">
      {MANIFESTO.map((m, i) => (
        <Reveal key={m.no} delay={i * 0.08}>
          <div data-testid={`manifesto-${i}`} className="grid md:grid-cols-[auto_1fr] gap-6 md:gap-12 py-10 group">
            <span className="font-display text-7xl md:text-8xl text-outline leading-none transition-all group-hover:[-webkit-text-stroke-color:#6BFF3D]">
              {m.no}
            </span>
            <div className="max-w-2xl">
              <h3 className="font-display text-4xl md:text-5xl text-white group-hover:text-weld-glow transition-colors">{m.title}</h3>
              <p className="text-white/60 mt-3 text-lg leading-relaxed">{m.text}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);
